import { useAppStore } from '@/stores/app';

export const hasInstanceLicense = () => !!useAppStore().appSettings?.licenseSettings;
